const imageWithBlockAccordion = document.querySelector('.image-with-block__accordion-tab');

if(imageWithBlockAccordion) {

    const imageWithBlockAccordionTabs = document.querySelectorAll('.image-with-block__accordion-tab .item');

    imageWithBlockAccordionTabs.forEach(item =>{

        const itemTitle = item.querySelector('.item__title');

        itemTitle.addEventListener('click', () =>{

            // CLOSE ALL TABS
            for(let i=0;i<imageWithBlockAccordionTabs.length;i++){
                const tabTitle = imageWithBlockAccordionTabs[i].querySelector('.item__title');
                if(tabTitle != itemTitle) {
                    const tab = imageWithBlockAccordionTabs[i];
                    tab.style.height = `60px`
                    tab.classList.remove('open');
                }
            }

            // OPEN CLICKED TAB
            const itemContent = item.querySelector('.item__content');

            if(item.classList.contains('open')){
                item.style.height = `60px`
                item.classList.remove('open');
            }else{
                item.style.height = `${itemContent.offsetHeight+60}px`
                item.classList.add('open');
            }

        })
        
    })

}